import { render, staticRenderFns } from "./newclass.vue?vue&type=template&id=6d533d5e&scoped=true"
import script from "./newclass.vue?vue&type=script&lang=js"
export * from "./newclass.vue?vue&type=script&lang=js"
import style0 from "./newclass.vue?vue&type=style&index=0&id=6d533d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d533d5e",
  null
  
)

export default component.exports